const ROUTES = {
  AUTH: '/auth',
  LOGIN: '/auth/login',
  LOCK: '/auth/lock',
  FORGOTPWD: '/auth/forgotPwd',
  RESETPWD: '/auth/reset-password/:token',

  ROOT: '/',
  DASHBOARD: '/',
  PROFILE: '/profile',

  SPACECARDS: '/space-cards',
  ADD_SPACECARD: '/space-card/create',
  EDIT_SPACECARD: '/space-card/:slug/edit',

  PROJECTS: '/projects',
  ADD_PROJECT: '/project/create',
  EDIT_PROJECT: '/project/:slug/edit',

  SEO: '/seo',
  ADD_SEO: '/seo/create',
  EDIT_SEO: '/seo/:id/edit',

  VERIFY_EMAIL: '/verify-email/:token',

  CMS: '/cms/:code',

  CTA_CONTACT_US: '/cta/contact-us',
  CTA_CAREER: '/cta/career',
};

export default ROUTES;
